import e from"react";import{actionsStyles as a}from"./Header.styles.js";const s=({children:s,className:t})=>e.createElement("div",{className:a.headerActions({className:t}),"data-testid":"header-actions"},s);export{s as default};
